export function isDeleteObjectKey(e){

  let result = ['Backspace','Delete'].includes(e.key);
  return result;
}
